var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from "@cloudscape-design/components/box";
/**
 * Component used to render the items in a dropdown menu. This component will be rendered inside a MenuUnstyled component and can handle keyboard arrow navigation.
 */
export function ToolbarButtonDropdownMenuItems(props) {
    var items = props.items, close = props.close, onKeyDown = props.onKeyDown;
    return (_jsx(_Fragment, { children: items.map(function (item) { return (_jsx("li", __assign({ 
            // Role set to none to allow us to use the button element as a menu item
            role: "none", className: "toolbar-dropdown-menu-item" }, { children: _jsxs("button", __assign({ role: "menuitem", 
                // Setting tabIndex to -1 to indicate that they can be focused programmatically but not by pressing the `Tab` key. The Tab key will be used to navigate to the next toolbar item
                tabIndex: -1, onClick: function () {
                    item.onClick();
                    close();
                }, onKeyDown: onKeyDown, "aria-label": item.name, "data-testid": item.testId }, { children: [item.icon, _jsx(Box, { children: item.name })] })) }), item.name)); }) }));
}
